import React from 'react';
import * as styles from './style.module.css';
import { Link } from 'gatsby';

const QuickLinks = ({ block }) => {
  const { links } = block;

  // console.log(links);

  return (
    <div className="container">
      <div className={styles.cardContainer}>
        {links.map((link) => (
          <div className={styles.card}>
            <Link to={link.slug}>{link.title}</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickLinks;
